;(function(EG) {
  var ACTIONS, CHECKBOX_NAME, CHECKED_PROPERTY, CHANGE_EVENT, DISABLED, errorTemplate;

  ACTIONS = {
    add: 'ADD',
    get: 'GET'
  };

  CHECKBOX_NAME = 'checkbox';
  CHECKED_PROPERTY = 'checked';
  CHANGE_EVENT = 'change';
  DISABLED = 'disabled';
  errorTemplate = Handlebars.templates['partials/common/error'];

  function resetPartialForm(partialFormResetConfig) {
    var isActiveElement, container, field, defaultvalue, containers, elem, $elem;
    containers = partialFormResetConfig;
    $.each(containers, function(index, value) {
      isActiveElement = value.active;
      container = value.container;
      field = value.findvalue;
      elem = $(container).find(String(field) + '');
      $elem = $(elem);
      defaultvalue = value.defaultvalue;

      if (isActiveElement == false || elem == undefined || elem.get(0) == undefined) {
        return;
      }

      if (elem.get(0).type == CHECKBOX_NAME) {
        $elem.prop(CHECKED_PROPERTY, defaultvalue);
      } else {
        $elem.val(defaultvalue);
      }
    });
  }

  function resetForm(params) {
    var $createUserForm, costCenters, $departments, $cdf, $actionButton, formName;

    $createUserForm = params.formElem;
    costCenters = params.costCenters;
    $departments = params.$departments;
    $cdf = params.cdfElem;
    $actionButton = params.actionButton;
    formName = params.formName;

    $createUserForm[0].reset();
    $("[name='userProfile[" + formName + "][user_authentication_mode]']").change();

    disableActionButtons($actionButton);

    _.each(costCenters, function(costCenter) {
      var $costCenterElem;

      $costCenterElem = $(costCenter.elem);

      $costCenterElem.val(null).trigger(CHANGE_EVENT);
      $costCenterElem.removeAttr(DISABLED);
    });

    if($departments) {
      $departments.val(null).trigger(CHANGE_EVENT);
    }
    $cdf.find('.cdf-list').each(function() {
      $(this)
        .val(null)
        .trigger('change');
    });
  }

  function disableActionButtons($actionButton) {
    var $actionBtns;

    $actionBtns = $actionButton;
    if(!_.isUndefined($actionBtns)){
      $actionBtns.attr('disabled', DISABLED);
    }
  }

  function displayMessage(params) {
    var messageLabel, messageType, response, message, $container, messageList;

    messageList = [];
    messageType = params.type;
    response = params.response;
    message = params.message;
    $container = params.commonMsgContainerId;

    switch (messageType) {
      case EG.Users.Constants.alertType.SUCCESS:
        messageLabel =
          message ||
          uitk.i18n.msg('create_user_successMsg', {
            arg0: response.first_name + ' ' + response.last_name
          });
          messageLabel = messageLabel.replace('{1}', response.user_id);
        break;
      case EG.Users.Constants.alertType.ERROR:
        messageLabel = message || EG.Users.Utils.getErrorDescription(response.error);
        break;
    }

    messageList.push({
      type: messageType,
      msg: messageLabel
    });

    $container.append(
      errorTemplate({
        messageList: messageList
      })
    );

    EG.Users.Utils.scrollTop($container[0]);
  }

  function clearPageMessage($commonMsgContainer) {
    $commonMsgContainer.html('');
  }


  EG.Users.Profile.View.Utils.UserSelfRegistration = {};
  EG.Users.Profile.View.Utils.UserSelfRegistration.resetPartialForm = resetPartialForm;
  EG.Users.Profile.View.Utils.UserSelfRegistration.resetForm = resetForm;
  EG.Users.Profile.View.Utils.UserSelfRegistration.displayMessage = displayMessage;
  EG.Users.Profile.View.Utils.UserSelfRegistration.disableActionButtons = disableActionButtons;
  EG.Users.Profile.View.Utils.UserSelfRegistration.clearPageMessage = clearPageMessage;
})(EG);
